import { render, staticRenderFns } from "./baobiao_kfjl.vue?vue&type=template&id=01b0e2e8&scoped=true"
import script from "./baobiao_kfjl.vue?vue&type=script&lang=js"
export * from "./baobiao_kfjl.vue?vue&type=script&lang=js"
import style0 from "./baobiao_kfjl.vue?vue&type=style&index=0&id=01b0e2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0e2e8",
  null
  
)

export default component.exports